import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import pdf from "../../../../assets/images/pdf-icon.png";
import "../utils/detail.css";
import ChiffresDaffaire from "./ChiffresDaffaire";
import MehodePaiement from "./MehodePaiement";
import Versement from "./Versement";
import OpenSecurePdf from "../../../../common/file/openFile";
import DocumentBusiness from "./document-business";
import { Button, Card } from "reactstrap";
import LienPaiement from "./lien-de-paiement";
import { FormatCurrency } from "../../../../common/format/formatCurrency";
import { addDocBusiness, getAmountFrozen, getDeveloperBalanceById, updateAmountFrozen } from "../services/developerApi";
import { Modal, Spin } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
const DeveloperInfo = ({ developer,onRefresh  }) => {
const [loadingDocs, setLoadingDocs] = useState(true);
const tabs = ["Vue d'ensemble", "Liens créés", "Transactions"];
const [activeTab1, setActiveTab1] = useState("Vue d'ensemble");
const handleTabChange = (tab1) => setActiveTab1(tab1);
const { logo = [] } = developer || {};
const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
const [balances, setBalances] = useState(null);
const [isFrozenModalOpen, setIsFrozenModalOpen] = useState(false);
const [frozenList, setFrozenList] = useState([]);
const [loading, setLoading] = useState(false);
useEffect(() => {
  const fetchBalances = async () => {
    try {
      const res = await getDeveloperBalanceById(developer?.id);
      setBalances(res);
    } catch (error) {
      console.error(error);
    }
  };
  if (developer?.id) {
    fetchBalances();
  }
}, [developer?.id]);
const openFrozenModal = async (developer) => {
  try {
    setLoading(true);

    const res = await getAmountFrozen(
      developer?.merchantId,
      developer?.id
    );
    const data = res?.data || res || [];
    setFrozenList(Array.isArray(data) ? data : []);
    setIsFrozenModalOpen(true);
  } catch (error) {
    console.error(error);
    setFrozenList([]);
  } finally {
    setLoading(false);
  }
};
const [documents, setDocuments] = useState({
  businessRegistryFileName: null,
  nineaFileName: null,
  statutFileName: null,
});
 const isValidSubmit = () => {
  return (
    documents.businessRegistryFileName ||
    documents.nineaFileName ||
    documents.statutFileName
  );
};
const [isSubmitting, setIsSubmitting] = useState(false);
const handleSubmitDocuments = async () => {
  if (!isValidSubmit()) {
    return toast.error("Veuillez compléter les documents requis");
  }
  setIsSubmitting(true);
  try {
    const files = {
      token:currentuser?.token,
      id:developer?.id,
      businessRegistryFileName: documents.businessRegistryFileName,
      nineaFileName:  documents.nineaFileName,
      statutFileName: documents.statutFileName,
    };
    const resp = await addDocBusiness(
      files,
    );
    toast.success("Documents soumis avec succès");
      if (onRefresh) {
      onRefresh();
      }
    setDocuments({
      businessRegistryFileName: null,
      nineaFileName: null,
      statutFileName: null,
    });
  } catch (err) {
    toast.error("Erreur lors de la soumission");
  } finally {
    setIsSubmitting(false);
  }
};
const handleAccept = async (id) => {
  try {
    await updateAmountFrozen(id, true);

    await openFrozenModal(developer);

    toast.success("Accepté");
  } catch (e) {
    toast.error("Erreur");
  }
};

const handleReject = async (id) => {
  try {
    await updateAmountFrozen(id, false);

    await openFrozenModal(developer); 

    toast.success("Rejeté");
  } catch (e) {
    toast.error("Erreur");
  }

};
  return (
    <>
  <Card 
  style={{
    padding: "12px",
    border: "1px solid #0000001A",
    borderRadius: "12px",  
    backgroundColor: "#FFFFFF",
    marginTop:'16px'
    }}
>
   <div className="row g-2">
  
  <div className="col-md-3">
    <Card className="card-business">
      {/* CARD 1 */}
      <div className="d-flex justify-content-between align-items-center naming">
        <span>Montant encaissé</span>
      </div>

      <div className="d-flex flex-column gap-1">
        <div className="CA"> {FormatCurrency(balances?.balance || 0)}</div>
      </div>
    </Card>
  </div>

  <div className="col-md-3">
    <Card className="card-business">
      <div className="d-flex justify-content-between align-items-center naming">
        <span>Transactions</span>
      </div>

      <div className="d-flex flex-column gap-1">
        <div className="CA">{(balances?.totalTransactions || 0)}</div>
      </div>
    </Card>
  </div>

  <div className="col-md-3">
    <Card className="card-business">
      <div className="d-flex justify-content-between align-items-center naming">
        <span>Solde disponible</span>
      </div>

      <div className="d-flex flex-column gap-1">
        <div className="CAD">{FormatCurrency(balances?.availableBalance || 0)}</div>
      </div>
    </Card>
  </div>
  <div className="col-md-3">
    <Card className="card-business">
     <div className="d-flex justify-content-between align-items-center naming">
  <span>Total montant gelé</span>

  <Button color="primary"
  className=" btn btn-primary"
    size="sm"
    style={{ padding: "2px 8px", height: "24px" }}
    onClick={() => openFrozenModal(developer)}
  >
    Voir
  </Button>
</div>
      <div className="d-flex flex-column gap-1">
         <div className="CAG">{FormatCurrency(balances?.totalFrozenAmount || 0)}</div>
      </div>
    </Card>
  </div>
</div>
</Card> 
    <Card  style={{ padding: "12px",marginTop:'40px',border: "1px solid #0000001A",borderRadius: "12px",backgroundColor: "#FFFFFF"}}>
    <div className="developer-info-container ">
      <div className="mb-4">
        <div className="tabs-scroll">
          {tabs.map((tab1) => (
            <div
              key={tab1}
              onClick={() => handleTabChange(tab1)}
              className={`tab-item ${activeTab1 === tab1 ? "active" : ""}`}
            >
              {tab1}
            </div>
          ))}
        </div>
      </div>
      {activeTab1 === "Vue d'ensemble" && (
        <>
          <Row className="mt-4 px-3 ">
            <Col md={6} sm={6} xs={12} className="mb-3">
              <label className="label">Nom business</label>
              <input
                type="text"
                value={developer?.businessName || "---"}
                className="form-control info-input w-100"
              />
            </Col>
            <Col md={6} sm={6} xs={12} className="mb-3">
              <label className="label">Date création</label>
              <input
                type="text"
                value={developer?.requestDate || "---"}
                className="form-control info-input w-100"
              />
            </Col>
          </Row>

          <Row className="px-3">
            <Col md={6} sm={6} xs={12} className="mb-3">
              <label className="label">Secteur</label>
              <input
                type="text"
                value={developer?.sectorName || "---"}
               className="form-control info-input w-100"
              />
            </Col>
            <Col md={6} sm={6} xs={12} className="mb-3">
              <label className="label">Pays</label>
              <input
                type="text"
                value={developer?.country || "---"}
                className="form-control info-input w-100"
              />
            </Col>
          </Row>
          <Row className="px-3 ">
            <Col md={12} sm={10} xs={12} className="mb-3">
              <label className="label">Commission bussiness</label>
              <input
                type="number"
                value={developer?.totalCommissionXof || "0.0"}
               className="form-control info-input w-100"
              />
            </Col>
          </Row>
          <Row className="px-3 ">
            <Col md={12} sm={10} xs={12} className="mb-3">
              <label className="label">Chiffre d’affaire annuel</label>
              <input
                type="number"
                value={developer?.balance || "0.0"}
               className="form-control info-input w-100"
              />
            </Col>
          </Row>
          <Row className="px-3 ">
            <Col md={12} sm={10} xs={12} className="mb-3">
              <label className="label">API KEY</label>
              <div className="fake-input">
                <span>{developer?.apiKey?.substring(0, 12)}</span>
                <span className="blurred">{developer?.apiKey?.substring(12) || "---"}</span>
              </div>
            </Col>
          </Row>

          <Row className="px-3">
            <Col md={12} sm={10} xs={12} className="mb-3">
              <label className="label">API Token</label>
              <div className="fake-input">
                <span>{developer?.apiToken?.substring(0, 12)}</span>
                <span className="blurred">{developer?.apiToken?.substring(12) || "---"}</span>
              </div>
            </Col>
          </Row>
      <DocumentBusiness
      developer={developer}
      currentuser={currentuser}
      loadingDocs={loadingDocs}
      OpenSecurePdf={OpenSecurePdf}
      documents={documents}
      setDocuments={setDocuments}
      handleSubmitDocuments={handleSubmitDocuments}
      isSubmitting={isSubmitting}
    />
      <MehodePaiement developer={developer} />
    </>
      )}

      {activeTab1 === "Liens créés" && <LienPaiement developer={developer} />}
      {/*{activeTab1 === "Soldes Carte bancaire" && <ChiffresDaffaire developer={developer} />}*/}
      {activeTab1 === "Transactions" && <Versement developer={developer} />}
    
    </div>
    </Card>
 <Modal
  title="Montants gelés"
  open={isFrozenModalOpen}
  onCancel={() => setIsFrozenModalOpen(false)}
  footer={null}
  width={500}
>
  {loading ? (
  <div style={{ textAlign: "center", padding: "20px" }}>
    ⏳ <Spin/>
  </div>
):!frozenList || frozenList.length === 0? (
    
    <div style={{ textAlign: "center", width: "100%" }}>
     Aucun Montants gelés
    </div>
  ) 
  : (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>

      {frozenList.map((item) => (
        <div
          key={item.id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "6px",
            borderRadius: "12px",
            backgroundColor: "#F8F8F8",
            border: "1px solid #F8F8F8"
          }}
        > 
          <div>
            <div style={{ fontWeight: 600 }}>
              {item.reference}
            </div>

            <div className="amount-blue">
              {item.amount} XOF
            </div>

            <div className="brozen">
              Demandé le 
              {item.date
                ? new Date(item.date).toLocaleDateString()
                : "-"}
            </div>
          </div>
        {item.status === "PENDING" ? (
  <div style={{ display: "flex", gap: "12px" }}>

    {/* ACCEPT */}
    <div style={{ textAlign: "center", cursor: "pointer" }}>
      <div
        style={{
          width: "34px",
          height: "34px",
          borderRadius: "50%",
          backgroundColor: "#FFFFFF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#0B6623",
          border: "2px solid #0B6623",
        }}
        onClick={() => handleAccept(item.id)}
      >
        <CheckOutlined />
      </div>
      <div className="brozen">Accepter</div>
    </div>

    {/* REJECT */}
    <div style={{ textAlign: "center", cursor: "pointer" }}>
      <div
        style={{
          width: "34px",
          height: "34px",
          borderRadius: "50%",
          backgroundColor: "#FFFFFF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#D41C1C",
          border: "2px solid #D41C1C",
        }}
        onClick={() => handleReject(item.id)}
      >
        <CloseOutlined />
      </div>
      <div className="brozen">Rejeter</div>
    </div>

  </div>
) : (
  <div>
    <span
      style={{
        padding: "4px 10px",
        borderRadius: "999px",
        fontSize: "13px",
        fontWeight: 500,
        backgroundColor:
          item.status === "SUCCESS" ? "#EBFFEA" : "#FFF0F0",
        color:
          item.status === "SUCCESS" ? "#349C32" : "#D41C1C",
      }}
    >
      {item.status === "SUCCESS" ? "Accepté" : "Rejeté"}
    </span>
  </div>
)}
 </div>
      ))}
    </div>
  )}
</Modal>
    </>
  );
};
export default DeveloperInfo;
